// A tagged envelope distinguishes rich documents from existing plain-text notes.
const DOCUMENT_PREFIX = 'mh-notes:v1:';

/**
 * Reads both legacy text and rich notes without interpreting text as HTML.
 *
 * @param {string} value - Stored value.
 * @returns {Object} Editor document.
 */
export function decodeNotes(value) {
    if (value.startsWith(DOCUMENT_PREFIX)) {
        try {
            const document = JSON.parse(value.slice(DOCUMENT_PREFIX.length));

            if (typeof document.text === 'string' && Array.isArray(document.richText?.ops)
                    && document.richText.ops.every(op => typeof op.insert === 'string')) {
                return { text: document.text,
                    richText: document.richText };
            }
        } catch {
            // Preserve unrecognized content as literal text.
        }
    }

    return { text: value,
        richText: null };
}

/**
 * Keeps native/plain notes compatible and stores rich formatting atomically.
 *
 * @param {string} text - Plain-text fallback.
 * @param {Object|null} richText - Quill Delta document.
 * @returns {string} Stored value.
 */
export function encodeNotes(text, richText) {
    return richText ? DOCUMENT_PREFIX + JSON.stringify({ text,
        richText }) : text;
}
